import React from 'react';
import './Logo.css';

const Logo = ({ size = 40, className = '', color = 'currentColor' }) => {
  return (
    <div className={`logo-container ${className}`} style={{ width: size, height: size, color: color }}>
      <svg 
        viewBox="0 0 100 100" 
        className="logo-svg"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* L形主体 - 水平部分 */}
        <rect 
          x="10" 
          y="60" 
          width="50" 
          height="20" 
          fill="currentColor" 
          className="logo-shape"
        />
        {/* L形主体 - 垂直部分 */}
        <rect 
          x="60" 
          y="20" 
          width="20" 
          height="40" 
          fill="currentColor" 
          className="logo-shape"
        />
        {/* 发光效果 - 水平部分下方 */}
        <ellipse 
          cx="35" 
          cy="85" 
          rx="30" 
          ry="8" 
          fill="currentColor" 
          opacity="0.3" 
          className="logo-glow"
        />
        {/* 发光效果 - 垂直部分右侧 */}
        <ellipse 
          cx="85" 
          cy="40" 
          rx="8" 
          ry="25" 
          fill="currentColor" 
          opacity="0.3" 
          className="logo-glow"
        />
      </svg>
    </div>
  );
};

export default Logo;

